/*
 * Copyright (c) 2023. Haodong JU
 */

export default {
  list: [
    {
      id: -11,
      color: 'brown lighten-5 black--text'
    }, {
      id: -10,
      color: 'deep-orange lighten-5'
    }, {
      id: -9,
      color: 'blue lighten-5 black--text'
    }, {
      id: -8,
      color: 'purple lighten-5 black--text'
    }, {
      id: -7,
      color: 'green lighten-5 black--text'
    }, {
      id: -6,
      color: 'teal lighten-5 black--text'
    }, {
      id: -5,
      color: 'indigo lighten-5 black--text'
    }, {
      id: -4,
      color: 'info lighten-2'
    }, {
      id: -3,
      color: 'orange lighten-5 black--text'
    }, {
      id: -2,
      color: 'grey lighten-4 black--text'
    }, {
      id: -1,
      color: 'blue-grey lighten-5 black--text'
    },
    {
      id: 0,
      color: 'error lighten-4 black--text'
    },
    {
      id: 1,
      color: 'amber lighten-4 black--text'
    }, {
      id: 2,
      color: 'success lighten-4 black--text'
    }, {
      id: 3,
      color: 'warning lighten-4 black--text'
    }, {
      id: 4,
      color: 'secondary lighten-4 black--text'
    }, {
      id: 5,
      color: 'accent lighten-4 black--text'
    }, {
      id: 6,
      color: 'tertiary lighten-4 black--text'
    }, {
      id: 7,
      color: 'info'
    }, {
      id: 8,
      color: 'pink'
    }, {
      id: 9,
      color: 'cyan'
    }, {
      id: 10,
      color: 'deep-purple lighten-4'
    }, {
      id: 11,
      color: 'lime'
    }, {
      id: 12,
      color: 'light-green'
    }, {
      id: 13,
      color: 'amber'
    }, {
      id: 14,
      color: 'yellow'
    }, {
      id: 15,
      color: 'deep-orange'
    }, {
      id: 16,
      color: 'blue lighten-4'
    }, {
      id: 17,
      color: 'blue-grey'
    }, {
      id: 18,
      color: 'yellow darken-4'
    }, {
      id: 19,
      color: 'brown lighten-5'
    }, {
      id: 20,
      color: 'deep-orange lighten-5'
    },
    {
      id: 21,
      color: 'yellow'
    }, {
      id: 22,
      color: 'deep-orange'
    }, {
      id: 23,
      color: 'blue lighten-4'
    }, {
      id: 24,
      color: 'blue-grey'
    }, {
      id: 25,
      color: 'yellow darken-4'
    }, {
      id: 26,
      color: 'brown lighten-5'
    }, {
      id: 27,
      color: 'deep-orange lighten-5'
    },
    {
      id: 31,
      color: 'info'
    },
    {
      id: 32,
      color: 'info'
    },
    {
      id: 33,
      color: 'info'
    },
    {
      id: 34,
      color: 'info'
    },
    {
      id: 35,
      color: 'info'
    },
    {
      id: 36,
      color: 'info'
    },
    {
      id: 37,
      color: 'info'
    },
    {
      id: 38,
      color: 'info'
    },
    {
      id: 39,
      color: 'info'
    },
    {
      id: 40,
      color: 'info'
    },
    {
      id: 41,
      color: 'info'
    },
    {
      id: 42,
      color: 'info'
    },
    {
      id: 43,
      color: 'info'
    },
    {
      id: 44,
      color: 'info'
    },
    {
      id: 45,
      color: 'info'
    },
    {
      id: 46,
      color: 'info'
    },
    {
      id: 47,
      color: 'info'
    },
    {
      id: 48,
      color: 'info'
    },
    {
      id: 49,
      color: 'info'
    },
    {
      id: 50,
      color: 'info'
    }
  ],
  getList: function () {
    return this.list
  }
}
